import React from 'react';
import { Badge } from '@/components/ui/badge';
import { BookOpen, Sparkles, AlertCircle } from 'lucide-react';
import { getEventCustomPlaybookStatusForType } from '@/lib/eventPlaybookDisplay';

function StatusIcon({ mode }) {
  if (mode === 'custom') return <Sparkles className="h-3.5 w-3.5 shrink-0 text-purple-700" />;
  if (mode === 'not_configured' || mode === 'custom_legacy') {
    return <AlertCircle className="h-3.5 w-3.5 shrink-0 text-amber-700" />;
  }
  return <BookOpen className="h-3.5 w-3.5 shrink-0 text-slate-600" />;
}

export default function EventCustomPlaybookStatusBanner({
  event,
  playbookKey,
  compact = false,
  onlyIfCustomActive = false,
  className = '',
}) {
  if (!event || !playbookKey) return null;

  const status = getEventCustomPlaybookStatusForType(event, playbookKey);

  if (onlyIfCustomActive && status.mode !== 'custom') {
    return null;
  }

  if (compact) {
    return (
      <p className={`text-[10px] leading-snug text-[#5C6B7A] min-h-[2.5rem] flex items-start gap-1.5 ${className}`}>
        <StatusIcon mode={status.mode} />
        <span>
          <Badge variant="outline" className={`text-[9px] px-1 py-0 mr-1 ${status.badgeClass}`}>
            {status.label}
          </Badge>
          {status.mode === 'custom' && status.stepCount != null
            ? `${status.stepCount} custom steps`
            : status.mode === 'default'
              ? 'Built-in sequence'
              : 'Uses default until configured'}
        </span>
      </p>
    );
  }

  return (
    <div
      className={`rounded-md border px-3 py-2.5 text-xs ${status.badgeClass} ${className}`}
      role="status"
    >
      <div className="flex items-center gap-2 font-medium">
        <StatusIcon mode={status.mode} />
        <Badge variant="outline" className={`text-[10px] ${status.badgeClass}`}>
          {status.label}
        </Badge>
        {status.mode === 'custom' && status.stepCount != null && (
          <span className="font-normal opacity-90">{status.stepCount} steps</span>
        )}
      </div>
      <p className="mt-1.5 text-[#0A1A2F]/80 leading-relaxed">{status.description}</p>
    </div>
  );
}
